<div class="main-content table-page table-page--compact proyectos-visualizacion-page">
  <div class="container-fluid">
    <ng-container *ngIf="mostrarPrincipal; else consultaRiesgosTpl">
      <section class="table-page__hero">
        <div class="table-page__copy">
          <h1>Gestión de Proyectos</h1>
          <p>Monitoree avances, esfuerzo, riesgos y etapas de cada proyecto desde una sola vista.</p>
        </div>

        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="openDialogAddProject()">
          <i class="material-icons">post_add</i>
          <span>Alta de Proyecto</span>
        </button>
      </section>

      <section class="table-page__card">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid">
            <div class="table-page__filter table-page__filter--wide">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Buscar proyecto</mat-label>
                <input
                  type="text"
                  matInput
                  maxlength="200"
                  (keyup)="onProjectNameChange()"
                  [(ngModel)]="nomProyecto"
                  autocomplete="off"
                  aria-label="Buscar proyecto"
                />
                <button *ngIf="nomProyecto" matSuffix mat-icon-button type="button" (click)="clearNombrePro()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--medium">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Cliente</mat-label>
                <mat-select
                  name="clientefl"
                  (selectionChange)="onClienteChange()"
                  [(ngModel)]="clientefl"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="formCliente"
                      [placeholderLabel]="'Buscar cliente'"
                      [noEntriesFoundLabel]="'No existe cliente'">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let item of listaClientes" [value]="item.razonsocial">
                    {{ item.razonsocial }}
                  </mat-option>
                </mat-select>
                <button *ngIf="clientefl" matSuffix mat-icon-button type="button" (click)="clearNombreCli()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--medium">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Estatus</mat-label>
                <mat-select [(ngModel)]="estatusFl" (selectionChange)="onChangeEstatus()">
                  <mat-option value="">Todos</mat-option>
                  <mat-option value="ACTIVO">Activo</mat-option>
                  <mat-option value="PAUSADO">Pausado</mat-option>
                  <mat-option value="CERRADO">Cerrado</mat-option>
                </mat-select>
                <button *ngIf="estatusFl" matSuffix mat-icon-button type="button" (click)="estatusFl = ''; onChangeEstatus()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--medium">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Proyectos</mat-label>
                <mat-select [(ngModel)]="filtroProyectoUsuario" (selectionChange)="onChangeFiltroProyectoUsuario()">
                  <mat-option value="MIS">Mis proyectos</mat-option>
                  <mat-option value="TODOS">Todos los proyectos</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="table-page__toolbar-actions">
            <div class="proyectos-visualizacion-page__counter">
              <span>Total de proyectos</span>
              <strong>{{ config?.totalItems || 0 }}</strong>
            </div>
          </div>
        </div>

        <div class="proyectos-visualizacion-page__content">
          <div class="proyectos-visualizacion-page__grid" *ngIf="paginatedProjects.length > 0; else proyectosEmptyState">
            <article class="proyectos-visualizacion-page__project-card" *ngFor="let item of paginatedProjects">
              <header class="proyectos-visualizacion-page__project-header">
                <div class="table-page__cell-stack">
                  <h2 class="proyectos-visualizacion-page__project-name">
                    <a [routerLink]="rutaPagina(item)" matTooltip="{{ item.nombre_corto }} - {{ item.nombre }}">
                      {{ item.nombre || "Sin nombre" }}<span class="material-icons" aria-hidden="true">chevron_right</span>
                    </a>
                  </h2>
                  <span class="table-page__subtext">{{ item.nombreCliente || "Sin cliente" }}</span>
                </div>

                <div class="proyectos-visualizacion-page__project-header-right">
                  <span class="table-page__status-badge" [ngClass]="item.uiStatusClass">
                    {{ item.uiStatus }}
                  </span>
                  <button type="button" class="table-page__action-btn" matTooltip="Editar proyecto" (click)="openDialogAditProject(item)">
                    <i class="material-icons">edit</i>
                  </button>
                  <a class="proyectos-visualizacion-page__ver-proyecto" [routerLink]="rutaPagina(item)"
                     [attr.aria-label]="'Ver proyecto ' + (item.nombre || '')">
                    Ver proyecto<span class="material-icons" aria-hidden="true">arrow_forward</span>
                  </a>
                </div>
              </header>

              <div class="proyectos-visualizacion-page__overview">
                <div class="proyectos-visualizacion-page__summary">
                  <section class="proyectos-visualizacion-page__summary-item">
                    <span class="proyectos-visualizacion-page__label">ID Proyecto</span>
                    <strong>{{ item.idProyecto || "-" }}</strong>
                  </section>

                  <section class="proyectos-visualizacion-page__summary-item">
                    <span class="proyectos-visualizacion-page__label">Responsable</span>
                    <strong>{{ item.nombreLider || "Sin responsable" }}</strong>
                  </section>

                  <section class="proyectos-visualizacion-page__summary-item">
                    <span class="proyectos-visualizacion-page__label">Planeación</span>
                    <strong>{{ item.uiDateRange }}</strong>
                  </section>

                  <section class="proyectos-visualizacion-page__summary-item proyectos-visualizacion-page__summary-item--wide">
                    <span class="proyectos-visualizacion-page__label">Descripción</span>
                    <strong>{{ item.descripcion || "Sin descripción registrada" }}</strong>
                  </section>
                </div>

                <section class="proyectos-visualizacion-page__commentary">
                  <div class="proyectos-visualizacion-page__section-head">
                    <span class="proyectos-visualizacion-page__label">Seguimiento reciente</span>
                    <button
                      *ngIf="item.comentariosAvances?.length > 0"
                      type="button"
                      class="table-page__action-btn"
                      matTooltip="Historial de avances"
                      (click)="verComentarios(item)">
                      <i class="material-icons">forum</i>
                    </button>
                  </div>

                  <div *ngIf="item.latestComment?.nombreUsuario; else sinComentariosTpl" class="table-page__cell-stack">
                    <span class="table-page__text">Fecha: {{ item.latestComment?.fecha }}</span>
                    <span class="table-page__subtext">Actualizado por {{ item.latestComment?.nombreUsuario }}</span>
                    <span class="table-page__description">{{ item.latestComment?.descripcion }}</span>
                  </div>

                  <ng-template #sinComentariosTpl>
                    <span class="table-page__subtext">No se han registrado actualizaciones</span>
                  </ng-template>
                </section>
              </div>

              <div class="proyectos-visualizacion-page__metrics">
                <section class="proyectos-visualizacion-page__metric-card proyectos-visualizacion-page__metric-card--compact">
                  <div class="proyectos-visualizacion-page__section-head">
                    <span class="proyectos-visualizacion-page__label">Avance</span>
                    <button
                      type="button"
                      class="table-page__action-btn"
                      matTooltip="Actualizar avance"
                      (click)="openDialogAditProject(item)">
                      <i class="material-icons">sync</i>
                    </button>
                  </div>

                  <div class="table-page__cell-stack">
                    <span class="table-page__text">Días hábiles: {{ item.uiDiasTotales }}</span>
                    <span class="table-page__subtext">Esperado: {{ item.uiDiasAvancePlaneado }} días</span>
                    <span class="table-page__subtext">Real: {{ item.uiDiasAvanceReal }} días</span>
                  </div>
                  <div class="proyectos-visualizacion-page__chart proyectos-visualizacion-page__chart--compact">
                    <canvas id="GraficaAvance-{{ item.id }}"></canvas>
                  </div>
                </section>

                <section class="proyectos-visualizacion-page__metric-card proyectos-visualizacion-page__metric-card--compact">
                  <div class="proyectos-visualizacion-page__section-head">
                    <span class="proyectos-visualizacion-page__label">Esfuerzo</span>
                  </div>

                  <div class="table-page__cell-stack">
                    <span class="table-page__text">Estimado: {{ item.horasTotales }} hrs.</span>
                    <span class="table-page__subtext">Real: {{ item.horasTotalesReales }} hrs.</span>
                  </div>
                  <div class="proyectos-visualizacion-page__chart proyectos-visualizacion-page__chart--compact">
                    <canvas id="GraficaEsfuerzo-{{ item.id }}"></canvas>
                  </div>
                </section>

                <section class="proyectos-visualizacion-page__metric-card proyectos-visualizacion-page__metric-card--risk">
                  <div class="proyectos-visualizacion-page__section-head">
                    <span class="proyectos-visualizacion-page__label">Riesgos y defectos</span>
                  </div>

                  <div class="proyectos-visualizacion-page__risk-layout">
                    <div class="proyectos-visualizacion-page__risk-summary">
                      <div class="proyectos-visualizacion-page__risk-list">
                        <div *ngFor="let severidad of severidad; index as i" class="proyectos-visualizacion-page__risk-item">
                          <span class="proyectos-visualizacion-page__risk-dot" [style.backgroundColor]="severidad.color"></span>
                          <span>{{ item.riesgoCantidad[i] }} {{ severidad.descripcion }}</span>
                        </div>
                      </div>

                      <div class="table-page__cell-stack">
                        <span class="table-page__subtext">Defectos: {{ totalDefectos(item) }}</span>
                      </div>
                    </div>

                    <div *ngIf="item.existenRiesgos; else sinRiesgosTpl" class="proyectos-visualizacion-page__chart proyectos-visualizacion-page__chart--risk">
                      <canvas id="riesgo-{{ item.id }}"></canvas>
                    </div>
                  </div>

                  <ng-template #sinRiesgosTpl>
                    <div class="proyectos-visualizacion-page__risk-empty">
                      <mat-icon>verified</mat-icon>
                      <span>Sin riesgos registrados</span>
                    </div>
                  </ng-template>
                </section>
              </div>

              <section class="proyectos-visualizacion-page__etapas" [attr.aria-labelledby]="'etapas-' + item.id">
                <div class="proyectos-visualizacion-page__section-head proyectos-visualizacion-page__etapas-head">
                  <h3 class="proyectos-visualizacion-page__label proyectos-visualizacion-page__etapas-titulo" [id]="'etapas-' + item.id">
                    Etapas ({{ filasDe(item).length }})
                  </h3>
                  <a class="proyectos-visualizacion-page__enlace" [routerLink]="rutaPagina(item)" [queryParams]="{ pestana: 'etapas' }"
                     [attr.aria-label]="'Ver etapas y versiones de ' + (item.nombre || '')">
                    Ver etapas y versiones<span class="material-icons" aria-hidden="true">chevron_right</span>
                  </a>
                </div>

                <div class="table-page__table-wrap proyectos-visualizacion-page__etapas-wrap" *ngIf="filasDe(item).length; else sinEtapasTpl">
                  <table class="table-page__table proyectos-visualizacion-page__etapas-tabla">
                    <caption class="cdk-visually-hidden">Etapas de {{ item.nombre }}</caption>
                    <thead>
                      <tr>
                        <th scope="col">Etapa</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Versión vigente</th>
                        <th scope="col">Última prueba</th>
                        <th scope="col">Abiertas</th>
                        <th scope="col"><span class="cdk-visually-hidden">Ver etapa</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let fila of filasDe(item); trackBy: trackEtapa">
                        <td>
                          <a class="proyectos-visualizacion-page__etapa-nombre" [routerLink]="rutaPagina(item)"
                             [queryParams]="{ pestana: 'etapas', etapa: fila.clave }">{{ fila.nombre }}</a>
                          <span class="proyectos-visualizacion-page__etapa-sub is-fechas">{{ fila.fechas }}</span>
                        </td>
                        <td>
                          <ng-container *ngIf="fila.chips.length; else etapaSinDatoTpl">
                            <span class="proyectos-visualizacion-page__etapa-chips">
                              <span *ngFor="let chip of fila.chips" class="table-page__status-badge proyectos-visualizacion-page__etapa-chip"
                                    [ngClass]="chip.clase" [attr.title]="chip.clase === 'is-pending' ? fila.tituloFueraDeFecha : null">
                                <span class="material-icons" aria-hidden="true">{{ chip.icono }}</span>{{ chip.texto }}
                              </span>
                            </span>
                            <span class="proyectos-visualizacion-page__etapa-sub" *ngIf="fila.detalleEstado">{{ fila.detalleEstado }}</span>
                          </ng-container>
                        </td>
                        <td>
                          <ng-container *ngIf="fila.vigente; else sinVigenteTpl">
                            <span class="proyectos-visualizacion-page__vigente">
                              <span class="table-page__status-badge is-active proyectos-visualizacion-page__etapa-chip">
                                <span class="material-icons" aria-hidden="true">check</span>Vigente
                              </span>
                              <strong>{{ fila.vigente }}</strong>
                            </span>
                            <span class="proyectos-visualizacion-page__etapa-sub" *ngIf="fila.lineaVigente">{{ fila.lineaVigente }}</span>
                          </ng-container>
                          <ng-template #sinVigenteTpl>
                            <span class="proyectos-visualizacion-page__sin-vigente">Sin versión vigente</span>
                            <button type="button" class="proyectos-visualizacion-page__crear-version" *ngIf="fila.crearVersion"
                                    [attr.aria-label]="'Crear versión en ' + fila.nombre" (click)="crearVersion(item, fila)">
                              <span class="material-icons" aria-hidden="true">add</span>Crear versión
                            </button>
                          </ng-template>
                          <!-- T3b: se entregan al crear la siguiente versión QA de la etapa. -->
                          <span class="proyectos-visualizacion-page__esperan" *ngIf="fila.esperanVersion">
                            <span class="material-icons" aria-hidden="true">schedule</span>{{ fila.esperanVersion }}
                          </span>
                          <button type="button" class="proyectos-visualizacion-page__crear-version" *ngIf="fila.nuevaVersion"
                                  [attr.aria-label]="'Nueva versión en ' + fila.nombre" (click)="crearVersion(item, fila)">
                            <span class="material-icons" aria-hidden="true">add</span>Nueva versión
                          </button>
                        </td>
                        <td>
                          <ng-container *ngIf="fila.ultimaPrueba as prueba; else etapaSinDatoTpl">
                            <span class="proyectos-visualizacion-page__prueba">
                              <strong>{{ prueba.titulo }}</strong><ng-container *ngIf="prueba.fecha"> · {{ prueba.fecha }}</ng-container>
                            </span>
                            <span class="proyectos-visualizacion-page__prueba-casos">
                              <span *ngIf="prueba.casos">{{ prueba.casos }}</span>
                              <span *ngIf="prueba.chip" class="table-page__status-badge proyectos-visualizacion-page__etapa-chip"
                                    [ngClass]="prueba.chip.clase">{{ prueba.chip.texto }}</span>
                            </span>
                          </ng-container>
                        </td>
                        <td>
                          <span class="proyectos-visualizacion-page__abiertas" [class.is-cero]="!fila.abiertas"
                                *ngIf="fila.abiertas !== null; else etapaSinDatoTpl">
                            <span class="proyectos-visualizacion-page__abiertas-punto" aria-hidden="true"></span>{{ fila.abiertas }}
                          </span>
                        </td>
                        <td class="proyectos-visualizacion-page__etapa-ver">
                          <a class="table-page__action-btn" [routerLink]="rutaPagina(item)" [queryParams]="{ pestana: 'etapas', etapa: fila.clave }"
                             [attr.aria-label]="'Ver etapa ' + fila.nombre" title="Ver etapa">
                            <span class="material-icons" aria-hidden="true">chevron_right</span>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <ng-template #etapaSinDatoTpl>
                  <span class="proyectos-visualizacion-page__sin-dato">{{ sinDato }}</span>
                </ng-template>

                <ng-template #sinEtapasTpl>
                  <p class="proyectos-visualizacion-page__etapas-vacio">El proyecto todavía no tiene etapas.</p>
                </ng-template>
              </section>

              <div class="proyectos-visualizacion-page__actions">
                <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--primary" (click)="irASeguimiento(item)">
                  <i class="material-icons">track_changes</i>
                  <span>Agregar seguimiento</span>
                </button>

                <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="openDialogAddStage(item)">
                  <i class="material-icons">add_circle_outline</i>
                  <span>Crear etapa</span>
                </button>

                <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="openModRiesgo(item)">
                  <i class="material-icons">warning</i>
                  <span>Agregar riesgo</span>
                </button>

                <button
                  *ngIf="item.existenRiesgos"
                  type="button"
                  mat-raised-button
                  class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  (click)="openConsultaRiesgo(item)">
                  <i class="material-icons">fact_check</i>
                  <span>Consultar riesgos</span>
                </button>
              </div>
            </article>
          </div>

          <ng-template #proyectosEmptyState>
            <div class="table-page__empty" *ngIf="!loading; else proyectosLoadingState">
              <i class="material-icons">folder_off</i>
              <strong>No se encontraron proyectos</strong>
              <span>Ajuste los filtros o registre un nuevo proyecto desde el botón superior.</span>
            </div>
          </ng-template>

          <ng-template #proyectosLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando proyectos...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ rangeEnd }} de {{ config?.totalItems || 0 }} proyectos</span>
            <span>Página {{ config.currentPage }} de {{ totalPages || 1 }}</span>

            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="config.itemsPerPage" (ngModelChange)="onPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>

          <div class="table-page__pager" *ngIf="totalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="config.currentPage === 1">
              Inicio
            </button>
            <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="config.currentPage === 1">
              Anterior
            </button>

            <ng-container *ngFor="let item of getPaginationItems()">
              <button
                *ngIf="isPageNumber(item); else proyectosPagerEllipsis"
                type="button"
                class="table-page__pager-page"
                [class.is-current]="item === config.currentPage"
                (click)="onPageChange(item)">
                {{ item }}
              </button>

              <ng-template #proyectosPagerEllipsis>
                <span class="table-page__pager-ellipsis">...</span>
              </ng-template>
            </ng-container>

            <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="config.currentPage === totalPages">
              Siguiente
            </button>
            <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="config.currentPage === totalPages">
              Último
            </button>
          </div>
        </div>
      </section>
    </ng-container>

    <ng-template #consultaRiesgosTpl>
      <app-consulta-riesgo
        [proyectoSeleccionado]="proyecto"
        (mostrarMascaraConsulta)="mostrarMascaraConsulta($event)"
        (mostrarPrincipal)="mostrarVistaPrincipal($event)">
      </app-consulta-riesgo>
    </ng-template>
  </div>
</div>
